import { REQUEST_SOCIAL_MEDIA, RECEIVE_SOCIAL_MEDIA, ISocialMediaState, SocialMediaTypes } from "./types";

const initialState: ISocialMediaState = {
    callbackData: {},
    isLoading: false,
};

export function socialMediaReducer(state = initialState, action: SocialMediaTypes): ISocialMediaState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_SOCIAL_MEDIA:
            return {
                isLoading: true,
                callbackData: state.callbackData,
            };
        case RECEIVE_SOCIAL_MEDIA:
            return {
                isLoading: false,
                callbackData: action.callbackData,
            };
        default:
            return state;
    }
}
